module.exports = __webpack_public_path__ + "3771a7ee49c2209f983c6f2888814062.MP3";